'use client';

import { useGlobalLoadingAtom } from '@/state';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import styles from './GlobalLoading.module.scss';

/**
 * pathname は Next.js 側でルートの DOM コミットより先に更新されることがあるため、
 * 即座にオーバーレイを外すと前ページが一瞬見えてちらつく。
 * 描画が終わるまで遅延してから stop する。
 */
function GlobalLoading() {
  const [isGlobalLoading, _, stopGlobalLoading] = useGlobalLoadingAtom();
  const pathname = usePathname();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (prevPathname.current !== pathname) {
      prevPathname.current = pathname;
      const pendingStopRafId = requestAnimationFrame(() => {
        stopGlobalLoading();
      });
      return () => cancelAnimationFrame(pendingStopRafId);
    }
  }, [pathname, stopGlobalLoading]);

  if (!isGlobalLoading) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.loader} />
    </div>
  );
}

export default GlobalLoading;
